module.exports = __webpack_public_path__ + "5b5cff9e1ad104e8dc97a084cf722e2c.png";